module.exports = __webpack_public_path__ + "img/bullhorn-solid.9b5a55a8.svg";